import { finalize } from 'rxjs/operators';

(() => {
	angular.module('main').directive('addAppointmentModal', addAppointmentModal);

	addAppointmentModal.$inject = [
		'$rootScope',
		'$location',
		'appointmentService',
		'calendarEventsDataService',
		'jobDataService',
		'messageService',
		'searchService',
		'timeService',
		'workflowService',
		'validationService',
		'settingsService',
		'timeConverter',
		'utilsService',
		'doubleBookingService'
	];

	function addAppointmentModal(
		$rootScope,
		$location,
		appointmentService,
		calendarEventsDataService,
		jobDataService,
		messageService,
		searchService,
		timeService,
		workflowService,
		validationService,
		settingsService,
		timeConverter,
		utilsService,
		doubleBookingService
	) {
		return {
			restrict: 'E',
			scope: {
				appointment: '<',
				activeJobs: '<',
				clientId: '<',
				jobId: '<',
				taskList: '=',
				updateView: '&',
				businessNumberLabelName: '='
			},
			template: `<section>
                            <div id="appointment" class="modal modal-center fade" data-backdrop="static" 
                                 data-keyboard="false" data-autotest-modal="appointment">
                                <div class="modal-dialog">
                                    <form ng-submit="saveAppointment()">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <btn-close></btn-close>
                                                <h3 class="modal-title">{{appointment.id ? 'Edit appointment' : 'Add new appointment'}}</h3>
                                            </div>
                                            <div class="modal-body f-s-14-labels">
                                                <h3 class="mt-0 mb-25">Appointment details</h3>
                                                <div class="flex-row flex-wrap-xs">
                                                    <div class="form-group w-min-100 flex-basis-full-xs">
                                                        <label class="control-label">Name</label>
                                                    </div>
                                                    <div class="form-group w-max-415 flex-with-full">
                                                        <input type="text" class="form-control" name="appointmentName" maxlength="255" ng-model="appointment.name" autocomplete="off"
                                                               required>
                                                    </div>
                                                </div>
                        
                                                <hr class="mt-15">
                        
                                                <h3 class="mt-30 mb-25">Appointment schedule</h3>
                        
                                                <div class="form-group">
                                                    <div class="flex-row flex-wrap-xs">
                                                        <div class="w-min-100 flex-basis-full-xs">
                                                            <label class="control-label">Date</label>
                                                        </div>
                        
                                                       
                                                            <div class="flex-row flex-wrap-xs flex-with-full w-max-415">
                                                                <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{'overlap-warning': !!doubleBookingData}">
                        
                                                                   <input ng-model="appointment.startDate" class="form-control"
                                                                           type="date" name="input" 
                                                                           data-placeholder="{{datapickerDateFormat}}" 
                                                                           min="2001-12-31"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                        
                                                                <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>
                        
                                                                <div class="flex-with-full flex-1 mb-15 box-no-transition-small datepicker-static under-input"  ng-class="{'overlap-warning': !!doubleBookingData}">
                                                                    <input ng-model="appointment.endDate" class="form-control w-150 flex-with-full"
                                                                           type="date" name="input"
                                                                          	data-placeholder="{{datapickerDateFormat}}" 
                                                                           min="{{( appointment.startDate ) ? ( appointment.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                                 
                                                            </div>
                                                       
                                                            <div class="mb-15 pt-6 flex-row flex-basis-full-xs" style="padding-left: 20px !important;">
                                                                        <div class="checkbox-squared">
                                                                            <input type="checkbox" id="checkbox-squared-all-day-appointment"
                                                                                   ng-model="appointment.allday"/>
                                                                            <label for="checkbox-squared-all-day-appointment"></label>
                                                                        </div>
                                                                        <label for="checkbox-squared-all-day-appointment">All day</label>
                                                            </div>
                        
                                                      
                                                    </div>
                                                    <div class="flex-row flex-wrap-xs">
                                                        <div class="w-min-100 flex-basis-full-xs">
                                                            <label class="control-label">Time</label>
                                                        </div>
                                                        <div class="job-date flex-with-full w-max-415">
                                                            <div class="flex-row flex-wrap-xs flex-basis-full-xs">
                                                                <div class="flex-1 mb-15 flex-with-full"  ng-class="{'overlap-warning': !!doubleBookingData}">
                                                                    <sn-timepicker sn-dr-model="appointment.startTime"
                                                                                   sn-dr-checked="appointment.allday"
                                                                    ></sn-timepicker>
                                                                </div>
                                                                <div class="flex-basis-xs flex-align-self-center ms-10 mb-15">to</div>
                                                                <div class="flex-1 mb-15 w-150 flex-with-full"  ng-class="{'overlap-warning': !!doubleBookingData}">
                                                                    <sn-timepicker sn-dr-model="appointment.endTime"
                                                                                   sn-dr-checked="appointment.allday"
                                                                    ></sn-timepicker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                        
                                                    <div class="flex-row flex-wrap-xs ">
                                                        <div class="w-min-100 flex-basis-full-xs">
                                                            <label class="control-label">Location</label>
                                                        </div>
                                                        <input type="text" class="hide hidden form-control" name="appointment.location"
                                                               ng-model="appointment.location"/>
                                                        <div class="mb-15 w-max-415 flex-with-full box-no-transition-small"
                                                             ng-controller="GoogleAutocompleteController">
                                                            <input type="text" id="AutocompleteAppointment" ng-model="autocomplete" placeholder=""
                                                                   class="form-control" ng-autocomplete options="options" details="details"/>
                                                        </div>
                                                    </div>
                                                                                                        
													<div class="row" ng-show="searchingEvents">
														<div class="col-sm-12">
															<div class="db-event-loading mt-10 mb-10">Loading...</div>
														</div>
													</div>
													<div class="row" ng-show="!searchingEvents && doubleBookingData">
														<div class="col-sm-12 mt-10 mb-25" >
															<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>
														</div>
													</div> 
												
                                                </div>
                                                <section ng-hide="isJobView || isLeadView">
                        
                                                    <hr class="mb-30">
                                                    <div class="flex-row mt-10 pb-10">
                                                        <div class="checkbox-squared">
                                                            <input type="checkbox" id="checkbox-squared-add-to-job"
                                                                   ng-model="appointment.addToJob"/>
                                                            <label for="checkbox-squared-add-to-job"
                                                                   data-autotest-checkbox="checkbox"></label>
                                                        </div>
                                                        <label for="checkbox-squared-add-to-job">
                                                            Add this appointment to the workflow of an active lead/job
                                                        </label>
                                                    </div>
                        
                                                    <div ng-show="appointment.addToJob" 
                                                         class="flex-row grey-group-field mb-0 mt-20 text-xs-center text-sm-left"
                                                         style="padding:23px">
                                                        <div class="mr-15">
                                                            <h4 class="f-normal">Choose active lead/job</h4>
                                                        </div>
                                                        <div class="flex-1 appointment-modal-input">
                                                            <input placeholder="Start entering job name"
                                                                   class="form-control"
                                                                   type="text"
                                                                   autocomplete="off"
                                                                   typeahead="idName as idName.name for idName in jobNames | filter:$viewValue"
                                                                   typeahead-on-select="enableViewButton($item)"
                                                                   typeahead-select-on-exact="true"
                                                                   ng-model="appointment.jobSearch">
                                                        </div>
                                                       
                                                        <a ng-disabled="viewButtonDisabled"
                                                        class="btn btn-default ml-10"
                                                        target="_blank"
                                                        ng-href="{{viewLeadJobLink}}">
                                                        	<i class="fi fi-view"></i>View
                                                        </a>
                                                    </div>
                                                    <hr class="mb-30">
                                                </section>
                                                <div class="flex-row mt-10 mb-10">
                                                    <div class="checkbox-squared">
                                                        <input type="checkbox" id="checkbox-squared-appointment-reminder"
                                                               ng-model="appointment.sendEmails"/>
                                                        <label for="checkbox-squared-appointment-reminder"
                                                               data-autotest-checkbox="checkbox"></label>
                                                    </div>
                                                    <label for="checkbox-squared-appointment-reminder">
                                                        Send appointment reminder to this client according to
                                                       <a class="pointer appointment-link" href="/settings/email_templates">Email Templates</a>
                                                    </label>
                                                </div>
                                                
                                                <div ng-show="!appointment.addToJob && appointment.sendEmails && !isJobView && !isLeadView" 
                                                         class="flex-row grey-group-field mb-0 mt-20 text-xs-center text-sm-left"
                                                         style="padding:23px">
                                                        <div class="mr-15">
                                                            <h4 class="f-normal">Choose client</h4>
                                                        </div>
                                                        <div class="flex-1 appointment-modal-input">
                                                            <input placeholder="Start entering client name"
                                                                   class="form-control" type="text"
                                                                   typeahead="idName as idName.name for idName in clientsNames | filter:$viewValue"
                                                                   ng-model="appointment.clientSearch">
                                                        </div>
                                                </div>
                        
                                            </div>
                                            <div class="modal-footer modal-foot">
                                                <button ng-disabled="button_disable" class="btn btn-success btn-lg" type="submit"
                                                        spinning-wheel is-spinning-wheel-active="button_disable"
                                                 >Save appointment</button>
                                                 
                                                 <button ng-disabled="button_disable" class="btn btn-lg btn-delete" 
                                                         ng-show="appointment.id && !isJobView && !isLeadView" ng-click="showDeleteAppointment(appointment, $event)" type="button"
                                                  >Delete</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        
                            <delete-appointment-modal delete="deleteAppointment(deleteId)"></delete-appointment-modal>
                        
                            <create-new-client-modal id="createNewClientModal"
                                                     company-name-checked="companyNameChecked"
                                                     client="newClient"
                                                     save-client="saveClient(event)"
                                                     on-close="closeAddClient()"
                                                     is-create-client-modal-spinnning-wheel-active="isAddNewSpinnningWheelActive"
                                                     business-number-label-name="businessNumberLabelName"
                            ></create-new-client-modal>
                        </section>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.isJobView = $location.path().includes('/jobs/view/');
				scope.isLeadView = $location.path().includes('/leads/view/');
				scope.job = {};
				const TIME = '12:00 PM';
				let clientsSearchTimer, jobSearchTimer;
				const input = $('input');

				$(document)
					.on('show.bs.modal', '#appointment', () => {
						scope.viewButtonDisabled = true;
						scope.viewLeadJobLink = null;
						scope.taskToAnimateNumber = null;
						scope.taskInfo = workflowService.getTaskInfo();
						if (
							scope.taskInfo &&
							scope.taskInfo.task &&
							scope.taskInfo.task.jobSearch &&
							(scope.taskInfo.task.jobSearch.id &&
								scope.taskInfo.task.jobSearch.name)
						) {
							scope.viewButtonDisabled = false;
							createLeadJobLink(scope.taskInfo.task.jobSearch);
						}
						settingsService.timeFormatSettings.subscribe(data => {
							if (data.timeFormat !== null) {
								scope.timeFormatIs12HorsFormat = data.timeFormat === 'T_12';
							}
						});
						scope.appointment = angular.copy(scope.taskInfo.task);
						scope.job.location = angular.copy(scope.appointment.location);

						settingsService.timeFormatSettings.subscribe(data => {
							scope.dataFormatMonth = data.dateFormat;
						});

						scope.datapickerDateFormat =
							scope.dataFormatMonth === 'DD_MM_YYYY'
								? 'dd/mm/yyyy'
								: 'mm/dd/yyyy';

						$('#appointment')
							.find('input.ws-date')
							.prop('autocomplete', 'off');

						if (scope.appointment.startDate) {
							convertDateTime();
						} else {
							scope.appointment.startTime = null;
						}
						scope.searchingEvents = false;
						scope.now = new Date();
						scope.now.setHours(0, 0, 0, 0);
						scope.clientsNames = [];
						scope.jobNames = [];
						scope.doubleBookingData = null;
						scope.$evalAsync();
					})
					.on('shown.bs.modal', '#appointment', function() {
						$(this)
							.find('input')
							.first()
							.focus();
						validationService.isModalClosePrevented(input);
					})
					.on('hide.bs.modal', '#appointment', () => {
						scope.appointment.startTime = undefined;
					});

				scope.$watch('appointment.startDate', checkAppointmentDate);
				scope.$watch('appointment.startTime', checkAppointmentTime);
				scope.$watch('appointment.endDate', reactToDateTimeChange);
				scope.$watch('appointment.endTime', reactToDateTimeChange);
				scope.$watch('appointment.allday', setTimeAfterAllDay);

				scope.$watch('appointment.location', setLocation);

				function checkAppointmentTime(newValue, oldValue) {
					if (
						scope.appointment &&
						typeof oldValue !== 'undefined' &&
						newValue &&
						newValue !== oldValue
					) {
						scope.appointment.endTime = timeService.setEndTime(newValue);
						reactToDateTimeChange(newValue, oldValue);
					}
				}

				function checkAppointmentDate(startDate) {
					if (scope.appointment && startDate) {
						if (
							!scope.appointment.endDate ||
							startDate > scope.appointment.endDate
						) {
							scope.appointment.endDate = startDate;
						}
						checkForOverlappingEvents();
					}
				}

				function setLocation(currentLocation) {
					scope.job.location = currentLocation;
				}

				function convertDateTime() {
					scope.appointment = timeService.convertDateTimeForPicker(
						scope.appointment,
						'startDate',
						'endDate',
						'startTime',
						'endTime'
					);
				}

				// client search

				scope.$watch('appointment.clientSearch', (newValue, oldValue) => {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}
						clientsSearchTimer = setTimeout(
							findAllMatchingClientNames(newValue),
							500
						);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				function findAllMatchingClientNames(search) {
					jobDataService
						.searchClient(search)
						.then(result => findClientSuccessCallback(result.data))
						.catch(messageService.showDefaultErrorMessage);
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.clientsNames.length = 0;
						client.forEach(item => scope.clientsNames.push(item));
					}
				}

				function setTimeAfterAllDay(newValue, oldValue) {
					if (!newValue && oldValue && !scope.timeFormatIs12HorsFormat) {
						scope.appointment.startTime = timeConverter.convert12to24(TIME);
					} else if (
						newValue === false &&
						oldValue &&
						scope.timeFormatIs12HorsFormat
					) {
						scope.appointment.startTime = TIME;
					} else if (newValue === true && oldValue === false) {
						scope.appointment.startTime = null;
						scope.appointment.endTime = null;
					}
					reactToDateTimeChange(newValue, oldValue);
				}

				scope.enableViewButton = function(event) {
					scope.viewLeadId = createLeadJobLink(event);
					scope.viewButtonDisabled = false;
				};

				// job search
				scope.$watch('appointment.jobSearch', (newValue, oldValue) => {
					if (newValue == null) {
						return;
					}
					if (oldValue == newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (jobSearchTimer != null) {
							clearTimeout(jobSearchTimer);
						}
						jobSearchTimer = setTimeout(
							findAllMatchingJobsNames(newValue),
							500
						);
					} else {
						clearTimeout(jobSearchTimer);
					}
				});

				function findAllMatchingJobsNames(search) {
					if (scope.activeJobs && scope.activeJobs.length) {
						scope.jobNames = searchService.findMatchingNames(
							scope.activeJobs,
							search
						);
					}
				}

				function createLeadJobLink(data) {
					if (data.leadId) {
						scope.viewLeadJobLink = `/leads/view/${data.leadId}`;
					} else if (data.id) {
						scope.viewLeadJobLink = `/jobs/view/${data.id}`;
					}
				}

				// save appointment

				scope.saveAppointment = function() {
					let dataToSave = angular.copy(scope.appointment);

					scope.button_disable = true;

					dataToSave.clientId = scope.clientId
						? scope.clientId
						: dataToSave.clientId;
					if (scope.isJobView === false) {
						scope.isJobView = scope.isLeadView;
					}
					dataToSave = appointmentService.prepareAppointmentToSave(
						dataToSave,
						scope.isJobView,
						scope.job.location
					);

					if (!dataToSave) {
						scope.button_disable = false;
						return false;
					}

					if (scope.isJobView || scope.isLeadView) {
						saveAppointmentAsJobTask(dataToSave);
					} else {
						saveAppointmentAsCalendarEvent(dataToSave);
					}
				};

				function saveAppointmentAsJobTask(dataToSave) {
					workflowService
						.saveTask(dataToSave, scope.jobId, scope.taskList)
						.finally(() => (scope.button_disable = false))
						.subscribe(
							result =>
								successSaveAppointmentAsTask(result, scope.appointment.id),
							error => messageService.showDefaultErrorMessage(error)
						);
				}

				function saveAppointmentAsCalendarEvent(dataToSave) {
					const action = dataToSave.id
						? calendarEventsDataService.updateEvent(dataToSave)
						: calendarEventsDataService.createEvent(dataToSave);

					action
						.finally(() => (scope.button_disable = false))
						.subscribe(
							data =>
								successSaveAppointment(
									data,
									scope.appointment.id,
									scope.appointment.jobId
								),
							error => messageService.showDefaultErrorMessage(error)
						);
				}

				function successSaveAppointmentAsTask(data, id) {
					if (!data || !data.tasks) {
						return;
					}

					scope.updateView({ tasks: data.tasks });

					for (let i = 0; i < data.tasks.length; i++) {
						if (data && data.taskMetadata && data.taskMetadata.taskId === data.tasks[i].id) {
							scope.taskToAnimateNumber = `.task-${i}`;
						}
					}

					const isEdited = id !== null && id !== undefined;

					isEdited
						? messageService.showToaster('s_4', 'workflow')
						: messageService.showToaster('s_3', 'workflow');

					$('#appointment')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							if (!isEdited) {
								$rootScope.$broadcast('animateTask', scope.taskToAnimateNumber);
							}
							$(this).off('hidden.bs.modal');
						});
				}

				function successSaveAppointment(data, appointmentId, oldJobId) {
					scope.button_disable = false;

					$('#appointment').modal('hide');

					const messageCode = appointmentId ? 's_1' : 's_0';
					messageService.showToaster(
						messageCode,
						'appointment',
						scope.appointment.name
					);

					const { jobId, taskId, leadId } = data;
					if (window.location.pathname !== '/calendar') {
						if (jobId && taskId) {
							redirectToJobLead('job', jobId, taskId);
						}
						if (leadId && taskId) {
							redirectToJobLead('lead', leadId, taskId);
						}
					}
					// if (
					// 	(taskId && !appointmentId) ||
					// 	(appointmentId && jobId !== oldJobId && (jobId || leadId))
					// ) {
					// 	$location.search('task', taskId).replace();
					// }
					scope.updateView({ resetPagination: false });
				}

				// redirect to lead/job

				function redirectToJobLead(pageName, id, taskId) {
					$location.path(`${pageName}s/view/${id}`).search('task', taskId);
				}

				// delete appointment

				scope.showDeleteAppointment = function(appointment, event) {
					scope.deleteId = appointment.id;
					scope.deleteAppointmentName = appointment.name;
					utilsService.showNextModal('#appointment', '#deleteModal', event);
				};

				scope.deleteAppointment = function(id) {
					$('#deleteModal').modal('hide');

					scope.button_disable = true;

					calendarEventsDataService
						.deleteEvent(id)
						.finally(() => (scope.button_disable = false))
						.subscribe(
							data => successDeleteAppointment(data),
							error => messageService.showDefaultErrorMessage(error)
						);
				};

				function successDeleteAppointment(data) {
					if (data && data.errorMessage) {
						messageService.showToaster('e_2', 'general', data.errorMessage);
					} else {
						$('#appointment').modal('hide');

						scope.updateView({ resetPagination: true });
						messageService.showToaster(
							's_2',
							'appointment',
							scope.deleteAppointmentName
						);
					}
				}

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (
						(scope.appointment && (newValue && newValue !== oldValue)) ||
						newValue === false
					) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					const hasDate =
						scope.appointment.startDate && scope.appointment.endDate;
					const hasTimeOrAllDay =
						scope.appointment.allday ||
						(scope.appointment.startTime &&
							scope.appointment.endTime &&
							!scope.appointment.allday);

					if (hasDate && hasTimeOrAllDay) {
						scope.timeData = {
							startTime: scope.appointment.startTime,
							startDate: scope.appointment.startDate,
							finishTime: scope.appointment.endTime,
							finishDate: scope.appointment.endDate,
							allday: scope.appointment.allday
						};
						scope.button_disable = true;
						scope.searchingEvents = true;
						const id = scope.appointment.calendarEvent
							? scope.appointment.calendarEvent.id
							: scope.appointment.id;

						doubleBookingService
							.getOverlappingEvents(
								doubleBookingService.gatherDateTimeData(scope.timeData),
								'EVENT',
								id
							)
							.pipe(
								finalize(() => {
									scope.searchingEvents = false;
									scope.button_disable = false;
								})
							)
							.subscribe(data => (scope.doubleBookingData = data));
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/addAppointmentModal.js